import request from './base';
import {excludeObjNullValue} from 'utils/common';

export const fetchCurrentAccount = () => request.getJSON('/account/profile');

export const login = (payload) => request.postJSON(
    '/login',
    excludeObjNullValue({
        email: payload.email,
        password: payload.password,
    })
);

export const logout = () => request.postJSON('/logout', null);

export const changePassword = (newPassword, oldPassword) => request.postJSON(
    '/changepassword',
    {
        password: newPassword,
        old_password: oldPassword
    });

export const changePasswordWithToken = (newPassword, token) => request.postJSON(
    '/passwordreset', {
        password: newPassword,
        token: token
    }
);

export const emailPasswordReset = (emailAddress) =>
    request.getJSON('/forgotpassword',
        {email: emailAddress});
